<template>
	<div>
		<div class="field has-addons slug" :class="{ 'is-error': showError }">
			<p class="control">
				<a class="button is-static">
					{{ label }}
				</a>
			</p>
			<div class="control">
				<input
					class="input"
					:class="[{ 'data-hj-whitelist': whitelist }]"
					type="text"
					:name="name"
					:value="value"
					:data-test="name"
					@input="input"
					@blur="myBlur"
				/>
			</div>
		</div>
		<p v-if="showError" class="help is-danger" :data-test="`error-${name}`">
			{{ error }}
		</p>
		<slot />
	</div>
</template>

<script>
import fieldMixin from "@lab/utils/fieldMixin";

export default {
	mixins: [fieldMixin],
	props: {
		label: {
			type: String,
			default: () => null
		},
		whitelist: {
			type: Boolean,
			default: () => false
		}
	},
	methods: {
		myBlur(val) {
			let slug = this.extractValue(val).toLowerCase();
			slug = slug.split(" ").join("-");
			this.blur(slug);
		}
	}
};
</script>

<style lang="scss">
.slug {
	margin-bottom: 0.75rem;
	&.is-error {
		border: 1px solid hsl(348, 100%, 61%);
		border-radius: 4px;
	}
	+ .help {
		margin-bottom: 0.75rem;
	}
}
</style>
